// DemoBookingThankYou.js
import React from "react";
import LargeHeaderTitle from "../components/LargeHeaderTitle";

const DemoBookingThankYou = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4">
      <LargeHeaderTitle title="You're Booked! " highlight="Confirmed" />
      <div className="max-w-2xl text-center mt-8 text-lg text-slate-200">
        <p className="mb-4">
          Thank you for booking your demo call! Please check your email and <strong>confirm</strong> your booking to secure your spot.
        </p>
        <p className="mb-4">
          Showing up is the first step to transforming your trading. We're excited to help you automate your success—don't miss out!
        </p>
        <p>
          If you need to reschedule, use the link in your confirmation email. We look forward to meeting you and helping you take your trading to the next level!
        </p>
      </div>
    </div>
  );
};

export default DemoBookingThankYou;
